export enum InvoiceTypeEnum {
  Proforma,
  Outgoing,
}
